import React from "react";
import Box from "../../components/Box";
import { toAbsoluteUrl } from "../../_metronic/helpers/AssetHelpers";
import { Helpers } from "../../helpers/Helpers";

const Page404Screen = () => {
    return (
        <Box flex={1} justifyContent="center" alignItems="center">
            <Box width="524px" overflow="hidden">
                <img alt='Logo' src={Helpers.get404()} />
            </Box>
        </Box>
    )
}

export default Page404Screen;